import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { axiosInstance } from '~/services';

import { API_ENDPOINT } from '~/constants';

import { receiveKeys } from './keys';

import type {
  TypeGetReceivingReportHistoriesParams,
  TypeGetReceivingReportHistoriesResponse,
} from '~/types/receive.types';

const fetchReportHistories = async (
  ownerCode: string,
  params: TypeGetReceivingReportHistoriesParams
): Promise<TypeGetReceivingReportHistoriesResponse> => {
  const { data } = await axiosInstance.get<TypeGetReceivingReportHistoriesResponse>(
    `${API_ENDPOINT.RECEIVE.GET_REPORT_HISTORIES}/${ownerCode}/report/histories`,
    { params }
  );
  return data;
};

type TypeUseGetReportHistoriesQueryParams = {
  ownerCode: string;
  params: TypeGetReceivingReportHistoriesParams;
  enabled?: boolean;
};

/**
 * [입고관리 > 입고 리포트 관리] 입고 리포트 목록 조회 Query Hook
 */
export const useGetReportHistoriesQuery = ({
  ownerCode,
  params,
  enabled = true,
}: TypeUseGetReportHistoriesQueryParams) => {
  return useQuery({
    queryKey: receiveKeys.reportHistories(ownerCode, params),
    queryFn: () => fetchReportHistories(ownerCode, params),
    enabled,
    staleTime: 0,
    gcTime: 1000 * 30,
    placeholderData: keepPreviousData,
  });
};
